var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h100"},[_c('Overlays'),(_vm.$store.state.uiState.isConfigurator)?_c('ConfiguratorMain'):_vm._e(),(_vm.$store.state.uiState.isViewer)?_c('ViewerMain',{attrs:{"objectId":_vm.lastRequestedId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }